import React from 'react'
import { Tag } from 'primereact';

import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid'


import { colorCotton, colorSintetico } from '../../../../../Styles/Colors';

export const IngresoQCScreen = ({ingresosQC, loading, plantaTratamiento}) => {



    const categoryTemplate = (rowData) => {
        switch (rowData.NombreTipo) {
            case 'Quimicos':
                return <Tag severity='danger' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorCotton }}/>
                break;
            case 'Colorantes':
                return <Tag severity='info' className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: colorSintetico }}/>
                break;
            case 'Spandex':
                return <Tag className='col-12' value={rowData.NombreTipo} style={{ backgroundColor: '#ffc605' }} />
                break;
        
            default:
                return <div>{rowData.NombreTipo}</div>
                break;
        }
    }

    const colums = [
        {
            header: 'Ingreso',
            field: 'IdIngreso',
            className: 'Xsmall'
        },
        {
            header: 'Fecha Ingreso',
            field: 'Fecha',
            Format: 'DateTime',
            className: 'small',
        },
        {
            header: 'Orden Ingreso',
            field: 'OrdenIngreso',
            className: 'small',
            Sumary: 'count'
        },
        {
            header: 'Factura',
            field: 'Factura',
        },
        {
            headerName: 'Producto',
            header: 'Producto',
            children: [
                {
                    header: 'Codigo Producto',
                    field: 'CodigoProducto',
                    className: 'small'
                },
                {
                    header: 'Categoria',
                    field: 'NombreCategoria',
                },
                {
                    header: 'Tipo',
                    field: 'NombreTipo',
                    className: 'small',
                    Format: 'Template',
                    body: categoryTemplate
                },
                {
                    header: 'Producto',
                    field: 'NombreProducto',
                    className: 'Xlarge'
                },
                {
                    header: 'Descripcion',
                    field: 'DescripcionProducto',
                },
            ]
        },
        {

            headerName: 'Proveedor',
            header: 'Producto',
            children: [
                {
                    header: 'CodigoProv',
                    field: 'CodigoProv',
                    className: 'small'
                },
                {
                    header: 'Proveedor',
                    field: 'Proveedor',
                    className: 'Xlarge'
                },
            ]

        },
        {
            header: 'Lote',
            field: 'Lote',
            className: 'medium'
        },
        {
            header: 'Estado',
            field: 'Estado',
            className: 'Xsmall'
        },
        {
            header: 'Moneda',
            field: 'Moneda',
            className: 'Xsmall'
        },
        {
            header: 'Unidad',
            field: 'Unidad',
            className: 'Xsmall'
            
        },
        {
            header: 'Cantidad',
            field: 'Cantidad',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right'
        },
        {
            header: 'Precio',
            field: 'Precio',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right'
        },
        {
            header: 'Total',
            field: 'Total',
            className: 'small',
            Format: 'Decimal',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right'
        },
        
        
    ]

    const table = {
        Data: ingresosQC,
        Columns: colums,
        loading: loading
    }

  return (
    <div className='p-2' style={{ height: '80vh' }}>
        <AgGrid table={table}/>
    </div>
  )
}
